export default __webpack_public_path__ + "static/media/add.112f645c.svg";